import styled from "styled-components";
import Trophy from "./Trophy";
import TwVgcDor from "./TwVgcDor";
import { trophyImages } from "../../../content-options/trophy";
import { useUser } from "../../../context/useUser";
import { FC} from "react";

interface ContainerProps {
  bg: string;
}

const TrophyWall: FC = ({}) => {
  const { user } = useUser();

  const floatingShapes = [
    { type: "circle", top: "66.59856996935649%", left: "13.020833333333334%", delay: "-0.9s" },
    { type: "triangle", top: "31.46067415730337%", left: "33.59375%", delay: "-4.8s" },
    { type: "cross", top: "76.50663942798774%", left: "38.020833333333336%", delay: "-4s" },
    { type: "square", top: "21.450459652706844%", left: "14.0625%", delay: "-2.8s" },
    { type: "square", top: "58.12053115423902%", left: "56.770833333333336%", delay: "-2.15s" },
    { type: "square", top: "8.682328907048008%", left: "72.70833333333333%", delay: "-1.9s" },
    { type: "cross", top: "31.3585291113381%", left: "58.541666666666664%", delay: "-0.65s" },
    { type: "cross", top: "69.96935648621042%", left: "81.45833333333333%", delay: "-0.4s" },
    { type: "circle", top: "15.117466802860061%", left: "32.34375%", delay: "-4.1s" },
    { type: "circle", top: "13.074565883554648%", left: "45.989583333333336%", delay: "-3.65s" },
    { type: "cross", top: "55.87334014300306%", left: "27.135416666666668%", delay: "-2.25s" },
    { type: "cross", top: "49.54034729315628%", left: "53.75%", delay: "-2s" },
    { type: "cross", top: "34.62717058222676%", left: "49.635416666666664%", delay: "-1.55s" },
    { type: "cross", top: "33.19713993871297%", left: "86.14583333333333%", delay: "-0.95s" },
    { type: "square", top: "28.19203268641471%", left: "25.208333333333332%", delay: "-4.45s" },
    { type: "circle", top: "39.7344228804903%", left: "10.833333333333334%", delay: "-3.35s" },
    { type: "triangle", top: "77.83452502553627%", left: "24.427083333333332%", delay: "-2.3s" },
    { type: "triangle", top: "2.860061287027579%", left: "47.864583333333336%", delay: "-1.75s" },
    { type: "triangle", top: "71.3993871297242%", left: "66.45833333333333%", delay: "-1.25s" },
    { type: "triangle", top: "31.256384065372828%", left: "76.92708333333333%", delay: "-0.65s" },
    { type: "triangle", top: "46.47599591419816%", left: "38.90625%", delay: "-0.35s" },
    { type: "cross", top: "3.4729315628192032%", left: "19.635416666666668%", delay: "-4.3s" },
    { type: "cross", top: "3.575076608784474%", left: "6.25%", delay: "-4.05s" },
    { type: "cross", top: "77.3237997957099%", left: "4.583333333333333%", delay: "-3.75s" },
    { type: "cross", top: "0.9193054136874361%", left: "71.14583333333333%", delay: "-3.3s" },
    { type: "square", top: "23.6976506639428%", left: "63.28125%", delay: "-2.1s" },
    { type: "square", top: "81.30745658835546%", left: "45.15625%", delay: "-1.75s" },
    { type: "square", top: "60.9805924412666%", left: "42.239583333333336%", delay: "-1.45s" },
    { type: "square", top: "29.009193054136876%", left: "93.90625%", delay: "-1.05s" },
    { type: "square", top: "52.093973442288046%", left: "68.90625%", delay: "-0.7s" },
    { type: "square", top: "81.51174668028601%", left: "83.59375%", delay: "-0.35s" },
    { type: "square", top: "11.542390194075587%", left: "91.51041666666667%", delay: "-0.1s" },
  ];

  return (
    <Container bg={trophyImages["bg"]}>
      <BackgroundWrapper>
        <BackShapes>
          {floatingShapes.map((shape, idx) => (
            <FloatingShape
              key={idx}
              className={`floating ${shape.type}`}
              style={{
                top: shape.top,
                left: shape.left,
                animationDelay: shape.delay,
              }}
            />
          ))}
        </BackShapes>
      </BackgroundWrapper>
      {user ? (
        <>
          {/* MOBILE & TABLET VIEW */}
          <DisplaySmall>
            {/* Row 1: D'Or centered */}
            <div className="row d-flex justify-content-center align-items-center mt-4">
              <div className="col-6 col-md-3">
                <TwVgcDor
                  quantity={user?.trophies?.vgcdOr}
                  trophy="vgcdOr"
                  fadedtrophy={"VGCdOrFaded"}
                />
              </div>
            </div>

            {/* Row 2: First 4 trophies */}
            <div className="row mt-3">
              <div className="col-6 col-md-3">
                <Trophy
                  quantity={user?.trophies?.goldenBoot}
                  trophy="goldenBoot"
                  fadedtrophy="GoldenBootFaded"
                />
              </div>
              <div className="col-6 col-md-3">
                <Trophy
                  quantity={user?.trophies?.mostPasses}
                  trophy="mostPasses"
                  fadedtrophy="BestPasserFaded"
                />
              </div>
              <div className="col-6 col-md-3">
                <Trophy
                  quantity={user?.trophies?.goldenGlove}
                  trophy="goldenGlove"
                  fadedtrophy="GoldenGloveFaded"
                />
              </div>
              <div className="col-6 col-md-3">
                <Trophy
                  quantity={user?.trophies?.cleanSheets}
                  trophy="cleanSheets"
                  fadedtrophy="MostCleanSheetsFaded"
                />
              </div>
            </div>

            {/* Row 3: Second 4 trophies */}
            <div className="row mt-3">
              <div className="col-6 col-md-3">
                <Trophy
                  quantity={user?.trophies?.mostHeaders}
                  trophy="mostHeaders"
                  fadedtrophy="MostHeadersFaded"
                />
              </div>
              <div className="col-6 col-md-3">
                <Trophy
                  quantity={user?.trophies?.mostTackles}
                  trophy="mostTackles"
                  fadedtrophy="TopTacklerFaded"
                />
              </div>
              <div className="col-6 col-md-3">
                <Trophy
                  quantity={user?.trophies?.mostAssists}
                  trophy="mostAssists"
                  fadedtrophy="MostAssistsFaded"
                />
              </div>
              <div className="col-6 col-md-3">
                <Trophy
                  quantity={user?.trophies?.mostIntercepts}
                  trophy="mostIntercepts"
                  fadedtrophy="MostInterceptsFaded"
                />
              </div>
            </div>
          </DisplaySmall>

          {/* DESKTOP VIEW */}
          <DisplayLarge>
            {/* top section with VCG D'Or */}
            <div className="row">
            <div className="col-lg-3 col-6 p-0">
              <div className=" ">
                <Trophy
                  quantity={user?.trophies?.goldenBoot}
                  trophy="goldenBoot"
                  fadedtrophy="GoldenBootFaded"
                  imgBottom="25%"
                  imgLeft="45%"
                  imgScale="0.8"
                />
              </div>
              <div className="">
                <Trophy
                  quantity={user?.trophies?.mostPasses}
                  trophy="mostPasses"
                  fadedtrophy="BestPasserFaded"
                  imgBottom="124%"
                  imgLeft="90%"
                  imgScale="0.8" 
                />
              </div>
            </div>
            {/* vgc d'or central on large screens */}
            <div className="col-lg-6 d-none d-lg-block mt-5">
              <TwVgcDor
                quantity={user?.trophies?.vgcdOr}
                trophy="vgcdOr"
                fadedtrophy="VGCdOrFaded"
                imgScale="1.2"
                imgBottom="-26%"
              />
            </div>
            <div className="col-lg-3 col-6 p-0">
              <div className=" ">
                <Trophy
                  quantity={user?.trophies?.goldenGlove}
                  trophy="goldenGlove"
                  fadedtrophy="GoldenGloveFaded"
                  imgBottom="33.5%"
                  imgLeft="30%" 
                  imgScale="0.6"
                />
              </div>
              <div className="">
                <Trophy
                  quantity={user?.trophies?.cleanSheets}
                  trophy="cleanSheets"
                  fadedtrophy="MostCleanSheetsFaded"
                  imgBottom="133%"
                  imgLeft="5%" 
                  imgScale="0.6"
                />
              </div>
            </div>
          </div>
          {/* bottom section */}
          <div className="row">
            <div className="col-lg-3 col-6">
              <Trophy
                quantity={user?.trophies?.mostHeaders}
                trophy="mostHeaders"
                fadedtrophy="MostHeadersFaded"
                imgBottom="234%"
                imgLeft="-65%" 
                imgScale="2.0"
              />
            </div>
            <div className="col-lg-3 col-6">
              <Trophy
                quantity={user?.trophies?.mostTackles}
                trophy="mostTackles"
                fadedtrophy="TopTacklerFaded"
                imgBottom="233%"
                imgLeft="-100%" 
                imgScale="2.0"
              />
            </div>
            <div className="col-lg-3 col-6">
              <Trophy
                quantity={user?.trophies?.mostAssists}
                trophy="mostAssists"
                fadedtrophy="MostAssistsFaded"
                imgBottom="130%"
                imgLeft="-290%" 
                imgScale="1.6"
              />
            </div>
            <div className="col-lg-3 col-6">
              <Trophy
                quantity={user?.trophies?.mostIntercepts}
                trophy="mostIntercepts"
                fadedtrophy="MostInterceptsFaded"
                imgBottom="128%"
                imgLeft="115%"
                imgScale="1.6" 
              />
            </div>
          </div>
          </DisplayLarge>
        </>
      ) : null}
    </Container>
  );
};

export default TrophyWall;

const Container = styled.div<ContainerProps>`
  min-height: 50vh;
  background-color: rgba(0, 0, 0, 1);
  display: block;
  border-radius: 8px;
  border: black 2px solid;
  padding-bottom: 4rem;
  position: relative;
  overflow: hidden;
  z-index: 0;

  /* Mobile background */
  @media (max-width: 767px) {
    background-color: #050a12;
    background-image: 
      linear-gradient(0deg, transparent 24%, rgba(255, 255, 255, 0.02) 25%, rgba(255, 255, 255, 0.02) 26%, transparent 27%, transparent 74%, rgba(255, 255, 255, 0.02) 75%, rgba(255, 255, 255, 0.02) 76%, transparent 77%, transparent),
      linear-gradient(90deg, transparent 24%, rgba(255, 255, 255, 0.02) 25%, rgba(255, 255, 255, 0.02) 26%, transparent 27%, transparent 74%, rgba(255, 255, 255, 0.02) 75%, rgba(255, 255, 255, 0.02) 76%, transparent 77%, transparent),
      linear-gradient(135deg, #050a12 0%, #0d1620 50%, #06080f 100%);
    background-size: 40px 40px, 40px 40px, 100% 100%;
    padding: 0 1rem;
  }

  /* Tablet background */
  @media (min-width: 768px) and (max-width: 1199px) {
    background-color: #050a12;
    background-image: 
      linear-gradient(0deg, transparent 24%, rgba(255, 255, 255, 0.02) 25%, rgba(255, 255, 255, 0.02) 26%, transparent 27%, transparent 74%, rgba(255, 255, 255, 0.02) 75%, rgba(255, 255, 255, 0.02) 76%, transparent 77%, transparent),
      linear-gradient(90deg, transparent 24%, rgba(255, 255, 255, 0.02) 25%, rgba(255, 255, 255, 0.02) 26%, transparent 27%, transparent 74%, rgba(255, 255, 255, 0.02) 75%, rgba(255, 255, 255, 0.02) 76%, transparent 77%, transparent),
      linear-gradient(135deg, #050a12 0%, #0d1620 50%, #06080f 100%);
    background-size: 40px 40px, 40px 40px, 100% 100%;
    padding: 0 2rem;
  }

  /* Desktop background - Original image */
  @media (min-width: 1200px) {
    background-image: url(${props => props.bg});
    background-size: cover;
    padding: 0 11rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

const BackgroundWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
  display: none;

  @media (max-width: 1199px) {
    display: block;
  }

  @media (min-width: 1200px) {
    display: none;
  }
`;

const BackShapes = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  animation: gridPulse 4s ease-in-out infinite;

  @keyframes gridPulse {
    0%, 100% {
      opacity: 0.1;
    }
    50% {
      opacity: 0.8;
    }
  }
`;

const FloatingShape = styled.span`
  position: absolute;
  animation-name: floating;
  -webkit-animation-name: floating;
  animation-duration: 5s;
  -webkit-animation-duration: 5s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  font-weight: bold;

  &.circle {
    color: #FF0000;
    width: 50px;
    height: 50px;
    font-size: 70px;
    
    &::before {
      content: "○";
    }
  }

  &.square {
    color: #FF20A0;
    width: 50px;
    height: 50px;
    font-size: 50px;
    
    &::before {
      content: "□";
    }
  }

  &.triangle {
    color: #00FF00;
    width: 50px;
    height: 50px;
    font-size: 40px;
    
    &::before {
      content: "△";
    }
  }

  &.cross {
    color: #0056FF;
    width: 35px;
    height: 35px;
    
    &::before {
      content: "✕";
      font-size: 32px;
    }
  }

  @keyframes floating {
    0% {
      transform: translateY(0%) rotate(-55deg);
    }
    50% {
      transform: translateY(300%) rotate(55deg);
    }
    100% {
      transform: translateY(0%) rotate(-55deg);
    }
  }

  @-webkit-keyframes floating {
    0% {
      -webkit-transform: translateY(0%) rotate(-55deg);
    }
    50% {
      -webkit-transform: translateY(300%) rotate(55deg);
    }
    100% {
      -webkit-transform: translateY(0%) rotate(-55deg);
    }
  }
`;

const DisplaySmall = styled.div`
  position: relative;
  z-index: 2;

  @media (min-width: 1200px) {
    display: none;
  }
`;

const DisplayLarge = styled.div`
  position: relative;
  z-index: 2;

  @media (max-width: 1199px) {
    display: none;
  }
`;
